const safeString = (value) => String(value ?? "").trim();

export const normalizeRole = (u = {}) => {
  const direct = safeString(u.role).toUpperCase();
  if (direct) return direct;
  const systemRole = safeString(u.system_role || u.systemRole).toUpperCase();
  if (systemRole) return systemRole;
  const managementRole = safeString(u.management_role || u.managementRole).toUpperCase();
  if (managementRole) return "ADMIN";
  const erpId = safeString(u.erpId || u.erp_id);
  if (erpId) return "STUDENT";
  const className = safeString(u.className);
  if (className && className !== "NA" && className !== "0") return "STUDENT";
  return "";
};

export const normalizeSchoolCode = (u = {}) =>
  safeString(
    u.selectedSchoolCode ||
      u.schoolCode ||
      u.school_id ||
      u.school_code
  );

export const normalizeSelectedSchoolCode = (u = {}) => {
  const selected = safeString(u.selectedSchoolCode);
  const hasMembershipContract = Array.isArray(u.memberships);
  const active = (hasMembershipContract ? u.memberships : []).filter((membership) =>
    safeString(membership?.status).toLowerCase() === "active");
  if (selected) {
    if (!hasMembershipContract) return selected;
    const match = active.find((membership) =>
      safeString(membership?.schoolCode).toLowerCase() === selected.toLowerCase());
    return match ? safeString(match.schoolCode) : "";
  }
  return active.length === 1 ? safeString(active[0]?.schoolCode) : "";
};

export const normalizeOrg = (u = {}) =>
  safeString(u.organization || u.school_name || u.schoolName);

export const normalizeName = (u = {}) => {
  const first = safeString(u.firstName || u.first_name);
  const last = safeString(u.lastName || u.last_name);
  const full = `${first} ${last}`.trim();
  return full || safeString(u.name) || safeString(u.displayName);
};

export const normalizeClassName = (u = {}) => {
  const direct = safeString(u.className || u.class || u.CLASS);
  if (direct) return direct;
  const assignmentClass = safeString(
    u?.assignments?.classTeacher?.className ||
      (Array.isArray(u?.assignments?.classes) ? u.assignments.classes[0]?.className : "")
  );
  if (assignmentClass) return assignmentClass;
  const scope = u.class_scope || u.classScope || [];
  if (Array.isArray(scope) && scope.length) {
    const first = scope[0];
    if (typeof first === "string") return safeString(first);
    if (first && typeof first === "object") {
      return safeString(first.className || first.class || first.name || "");
    }
  }
  return "";
};

export const normalizeSection = (u = {}) => {
  const direct = safeString(u.section || u.SECTION).toUpperCase();
  if (direct) return direct;
  const assignmentSection = safeString(
    u?.assignments?.classTeacher?.section ||
      (Array.isArray(u?.assignments?.classes) ? u.assignments.classes[0]?.section : "")
  ).toUpperCase();
  if (assignmentSection) return assignmentSection;
  const scope = u.class_scope || u.classScope || [];
  if (Array.isArray(scope) && scope.length) {
    const first = scope[0];
    if (first && typeof first === "object") {
      return safeString(first.section || "").toUpperCase();
    }
  }
  return "";
};

export const normalizeEmail = (u = {}) =>
  safeString(u.email || u.userId || u.user_id || u.loginId || u.login_id);
